import { useGetButterflyAccessPoints } from '@/api/keyless/butterfly/get-butterfly-access-points'
import { useGetButterflyConnection } from '@/api/property-keyless/butterfly/get-butterfly-connection'

import { butterflyDefaultValues } from './butterfly.schema'

// Note: `authorizationCode` is intentionally never pre-filled — the GET response never
// returns it (write-only, single-use), and a fresh code is required on every submit since
// there's no separate "update config only" endpoint (see use-butterfly-submit.ts).
export const useButterflyConnection = (buildingId: number) => {
  const { data, isSuccess, isLoading } = useGetButterflyConnection({ buildingId })
  const { data: doors, isLoading: isLoadingDoors } = useGetButterflyAccessPoints({ buildingId })

  const values = {
    ...butterflyDefaultValues,
    shouldAutoAssignApartmentDoorVisitor: data?.shouldAutoAssignApartmentDoorVisitor ?? false,
    visitorPermissionDoors: data?.visitorPermissionDoors ?? [],
  }

  return {
    doors: doors ?? [],
    isConfigured: isSuccess,
    isLoading,
    isLoadingDoors,
    values,
  }
}
